// extracted by mini-css-extract-plugin
export default {"selector":"IzPcJQkVwRfhhkrmLZpD","popup":"x7emWqxHD0oajNzGpy2l"};